import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { Divider } from '@design-system/divider';
export const SectionTitle = (_a) => {
    var { title } = _a, props = __rest(_a, ["title"]);
    return (_jsxs(Box, Object.assign({ flexDirection: "column" }, props, { children: [_jsx(Box, { font: "h4-semibold", children: title }), _jsx(Divider, { my: 2 })] })));
};
//# sourceMappingURL=SectionTitle.js.map